import React, { useState } from "react";
import { Upload, Button, Tooltip } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./FileUpload.css";
import axios from "axios";
import { Error } from "../../Messages/Messages";
import Loading from "../../Loading/Loading";

const FileUpload = ({ value, updateFileFun }) => {
  const { t } = useTranslation("dashboard");
  const [loading, setLoading] = useState(false);

  const props = {
    beforeUpload: file => {
      const isValidType =
        file.type.startsWith("image/") ||
        file.type.startsWith("video/") ||
        file.type === "application/pdf" ||
        file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      if (!isValidType) {
        Error(t("You can only upload image, video, PDF, or DOCX files!"));
        return Upload.LIST_IGNORE;
      } else {
        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        axios
          .post(`${process.env.REACT_APP_BACKEND_URL}/files/upload`, formData, {
            headers: {
              authorization: "Bearer " + localStorage.getItem("token")
            }
          })
          .then(res => {
            setLoading(false);
            if (res.status === 200) {
              updateFileFun(res.data);
            } else {
              Error(res.data.errorMessage);
            }
          })
          .catch(err => {
            setLoading(false);
            Error(err?.message);
          });
      }
    },
    maxCount: 1
  };

  return (
    <div className="file-upload">
      <Upload {...props} multiple={false} showUploadList={false}>
        <Tooltip title={t("Attach file")}>
          <Button
            type="text"
            icon={<LinkOutlined />}
            aria-label={t("Attach file")}
            className={value ? "file-upload__trigger--attached" : undefined}
          />
        </Tooltip>
      </Upload>
      <div className="filRender">{loading && <Loading />}</div>
    </div>
  );
};

export default FileUpload;
